import styled from 'styled-components';
import { IconButton } from 'ui-components/src/components/atoms/IconButton';

interface BarProps {
  $active: boolean;
}

export const Bar = styled.div<BarProps>`
  display: flex;
  z-index: 99;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3.125rem;
  background-color: ${({ theme }) => theme.colors?.lightBlue};
  color: ${({ theme }) => theme.colors?.white};
  transition: transform 0.3s, opacity 0.3s;
  transform: ${(props: { $active: boolean }) =>
    props.$active ? 'translateY(0)' : 'translateY(50px)'};
  opacity: ${(props: { $active: boolean }) => (props.$active ? 1 : 0)};
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  margin: 0 10px;
`;

export const Message = styled.span`
  line-height: 1;
`;

export const StyledIconButton = styled(IconButton)`
  margin-left: 0.5rem;
  svg {
    fill: #fff;
    height: 1rem;
    width: 1rem;
  }
`;
